/**
 * Color palette configuration for Material-UI v7 theme
 * Migrated from legacy Gatsby theme with Meteo France brand colors
 */

/**
 * Primary colors - Meteo France brand
 */
export const primary = {
  main: '#db0084',
  light: '#ff4fb8',
  dark: '#a20054',
  contrastText: '#ffffff',
};

/**
 * Secondary colors - Official blue palette
 */
export const secondary = {
  main: '#003661',
  light: '#036ba1',
  dark: '#002245',
  contrastText: '#ffffff',
};

/**
 * Neutral and text colors
 */
export const neutral = {
  main: '#7d7d7d',
  light: '#adadad',
  dark: '#4f4f4f',
  contrastText: '#ffffff',
};

/**
 * Background colors
 */
export const background = {
  default: '#ffffff',
  paper: '#ffffff',
  neutral: '#f5f5f5',
};

/**
 * Text colors with climate theme
 */
export const text = {
  primary: '#02568d',
  // #757575 (4.61:1 on white) instead of #7d7d7d (4.12:1) to meet WCAG AA 1.4.3
  secondary: '#757575',
  disabled: 'rgba(2, 86, 141, 0.38)',
};

/**
 * Additional theme colors for climate visualization
 */
export const climate = {
  temperature: {
    cold: '#0074d9',
    mild: '#39cccc',
    warm: '#ff851b',
    hot: '#ff4136',
  },
  risk: {
    low: '#2ecc40',
    medium: '#ffdc00',
    high: '#ff851b',
    critical: '#ff4136',
  },
  outlook: {
    2030: '#00c9f8',
    2050: '#0074d9',
    2100: '#003661',
  },
};

/**
 * Complete palette configuration for MUI v7
 */
export const palette = {
  primary,
  secondary,
  background,
  text,
  neutral,
  climate,
  
  // MUI v7 specific
  mode: 'light',
  divider: 'rgba(2, 86, 141, 0.12)',
  
  // Action colors
  action: {
    active: 'rgba(2, 86, 141, 0.54)',
    hover: 'rgba(2, 86, 141, 0.04)',
    selected: 'rgba(2, 86, 141, 0.08)',
    disabled: 'rgba(2, 86, 141, 0.26)',
    disabledBackground: 'rgba(2, 86, 141, 0.12)',
  },
  
  // Status colors
  error: {
    main: '#f44336',
    light: '#e57373',
    dark: '#d32f2f',
    contrastText: '#fff',
  },
  warning: {
    main: '#ff9800',
    light: '#ffb74d',
    dark: '#f57c00',
    contrastText: '#fff',
  },
  info: {
    main: '#2196f3',
    light: '#64b5f6',
    dark: '#1976d2',
    contrastText: '#fff',
  },
  success: {
    main: '#4caf50',
    light: '#81c784',
    dark: '#388e3c',
    contrastText: '#fff',
  },
};

export default palette;
